import { PayExemption, ProcessConfigPayExemption } from '@/Domain/Entities';
import { PayExemptionTypes } from '@/Domain/enum';

export default class Fees {
    private _hasFeePayment: boolean;
    private _payExemptionTypes: BigInt[];
    private _amount: number | null;
    private _payExemptionTypesView: PayExemption[];
    private _paymentType: BigInt |number | null;
    
    public constructor(data: any, processConfigurationPayExemptions?: ProcessConfigPayExemption[]) {
        this._hasFeePayment = data.fees ? data.fees.hasFeePayment : false;
        this._payExemptionTypes = data.fees ? data.fees.payExemptions : [];
        this._amount = data.fees ? data.fees.amount : null;
        this._paymentType = data.fees ? data.fees.feePaymentType : null;
        this._payExemptionTypesView = this.setPayExemptionTypesView(data, processConfigurationPayExemptions);
    }

    public get hasFeePayment() {
        return this._hasFeePayment;
    }

    public set hasFeePayment(value: boolean) {
        this._hasFeePayment = value;
    }
    public get payExemptionTypes() {
        return this._payExemptionTypes;
    }

    public set payExemptionTypes(payExemptionTypes: BigInt[]) {
        this._payExemptionTypes = payExemptionTypes;
    }

    public get amount() {
        return this._amount;
    }

    public set amount(amount: number | null) {
        this._amount = amount;
    }

    public get payExemptionTypesView() {
        return this._payExemptionTypesView;
    }

    public set payExemptionTypesView(value: PayExemption[]) {
        this._payExemptionTypesView = value;
    }

    public get paymentType() {
        return this._paymentType;
    }

    public set paymentType(value: BigInt | number | null) {
        this._paymentType = value;
    }

    public setPayExemptionTypesView(data, processConfigurationPayExemptions) {
        // CON-451: descuentos e importes se referencian por Guid (string), no por el antiguo bit.
        // Ya NO se convierten a BigInt (los Guids no son numéricos).
        return this.mapPayExemption(
            data.payExemptionFeeAmounts || [],
            data.fees ? (data.fees.payExemptions || []) : [],
            processConfigurationPayExemptions || []);
    }

    public mapPayExemption(payExemptionFeeAmounts, payExemptionValues, processConfigurationPayExemptions) {
        return processConfigurationPayExemptions.filter(payExemption => payExemption.type !== PayExemptionTypes.enum.NONE && payExemption.type !== PayExemptionTypes.enum.NOREASON)
            .map(payExemption => {
                // El descuento se casa por su Guid (payExemption.id); PEFA lo referencia en payExemptionType.
                const hasAmount = payExemptionFeeAmounts.find(payExe => payExe.payExemptionType === payExemption.id);
                return new PayExemption({
                    id: payExemption.id,
                    text: payExemption.title,
                    value: payExemptionValues.some(elem => elem === payExemption.id),
                    type: payExemption.type,
                    amount: hasAmount ? hasAmount.amount : null
                });
            });
    }

    public resetReasons() {
        if (!this.hasFeePayment) {
            this._payExemptionTypesView.forEach((element: PayExemption) => element.value = false);
            this.amount = null;
            this.paymentType = null;
        }
    }

    public setAmountToServer() {
        if (!this.hasFeePayment) {
            this.amount = null;
        }
    }

    public setPayExemptionAmountToServer() {
        this.payExemptionTypesView.forEach(payExemption => {
            if (!payExemption.value) {
                payExemption.amount = null;
            }
        });
    }

    public toServer(payExemptionsTypes: PayExemption[]) {
        return {
            hasFeePayment: this.hasFeePayment,
            // CON-451: el backend espera los descuentos ofertados por su Guid (id), no por el antiguo bit.
            payExemptions: payExemptionsTypes.map(payExemption => payExemption.id),
            amount: this.amount,
            feePaymentType: this.paymentType
        };
    }
}
